import React from "react";
import "./RoofTypeTab.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
// @ts-ignore
import RadioBlocks from "src/components/Input/RadioBlocks/RadioBlocks";
import Text from "src/components/Text/Text";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";

const roofTypes = [
  {
    id: 1,
    name: "Platdak",
    imageUrl: "./images/platdak.png",
    color: "",
    value: "platdak",
    price: 0,
    description: "",
  },
  {
    id: 2,
    name: "Kapschuur",
    imageUrl: "./images/kapschuur.png",
    color: "",
    value: "kapschuur",
    price: 0,
    description: "",
  },
];

const RoofTypeTab: React.FC = () => {
  const { state, setRoofType } = useConfiguration();

  const handleRoofTypeChange = (roofType: string) => {
    if (state.roofType !== roofType) setRoofType(roofType);
  };

  return (
    <div className="roof-type-tab">
      {/* <Text content="Kies uw afmetingen" /> */}
      <RadioBlocksExtended
        blocks={roofTypes}
        value={state.roofType}
        onChange={handleRoofTypeChange}
        // className={"root-type-radio-blocks"}
      />
    </div>
  );
};

export default RoofTypeTab;
